import "./SetupSafetyAndMaintenance.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Setuprequirements from "./sections/Setuprequirements";
import LocationPlanning from "./sections/LocationPlanning";
import Requirements from "./sections/Requirements";
import PowerRequirements from "./sections/PowerRequirements";
import ArenaSetup from "./sections/ArenaSetup";
import Placement from "./sections/Placement";
import Checklist from "./sections/Checklist";
import Preparation from "./sections/Preparation";
import RiderRules from "./sections/RiderRules";
import SetupChecks from "./sections/SetupChecks";
import Comparison from "./sections/Comparison";
import Storage from "./sections/Storage";
import Maintenance from "./sections/Maintenance";
import DeliveryPlanning from "./sections/DeliveryPlanning";
import SetupChecklist from "./sections/SetupChecklist";
import Faq from "./sections/Faq";
import PlanBullSetup from "./sections/PlanBullSetup";
import Footer from "@/reusable_sections/Footer";
export default function SetupSafetyAndMaintenancePage() {
  return <div>
      <Header />
      <Hero />
      <Setuprequirements />
      <LocationPlanning />
      <Requirements />
      <PowerRequirements />
      <ArenaSetup />
      <Placement />
      <Checklist />
      <Preparation />
      <RiderRules />
      <SetupChecks />
      <Comparison />
      <Storage />
      <Maintenance />
      <DeliveryPlanning />
      <SetupChecklist />
      <Faq />
      <PlanBullSetup />
      <Footer />
    </div>;
}